import { Component, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { QuillModule } from "ngx-quill";

import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { ScrollToModule } from "ng2-scroll-to-el";

import { SortableModule } from "ngx-bootstrap/sortable";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ModalModule } from "ngx-bootstrap/modal";

import { NgbDatepickerModule } from "@ng-bootstrap/ng-bootstrap";

import { DiscardModalComponent } from "./components/discard-modal.component";
import { AssessmentComponent } from "./components/assessments/assessment.component";
import { NoteEditComponent } from './components/notes/note-edit.component';
import { NoteEditModalComponent } from "./components/notes/note-edit-modal.component";

import { CareerPlanListComponent } from "./components/career-plan/careerplan-list.component";
import { CareerPlanSelectComponent } from "./components/career-plan/careerplan-select.component";
import { AccordionModule } from 'ngx-bootstrap/accordion';

import { CareerPlanActivitySelectComponent } from "./components/career-plan/careerplan-activity-select.component";

//Confirm Modal
import { ConfirmModalComponent } from '../shared/components/confirm-modal.component';


//Debounce Directive
import { DebounceDirective } from './directives/debounce.directive';
import { BookmarkComponent } from "./components/bookmark.component";
import { CasemanagerviewComponent } from './casemanagerview.component';
import { IdentityService } from "../employment101/services/identity.service";

//Safe Transform
import { SafePipe } from './pipes/safe.transform';

import { PopoverModule, PopoverConfig } from 'ngx-bootstrap/popover';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AccordionModule.forRoot(),
    SortableModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    NgbDatepickerModule,
    RouterModule,
    ScrollToModule.forRoot(),
    QuillModule.forRoot(),
    PopoverModule.forRoot(),

  ],
  declarations: [
    DiscardModalComponent,
    AssessmentComponent,
    NoteEditModalComponent, NoteEditComponent, DebounceDirective,
    CareerPlanListComponent, CareerPlanSelectComponent, CareerPlanActivitySelectComponent,
    BookmarkComponent,
    CasemanagerviewComponent,
    ConfirmModalComponent, SafePipe
  ],
  exports: [
    CommonModule,
    FormsModule, ReactiveFormsModule, BrowserAnimationsModule,
    SortableModule,
    AccordionModule,
    BsDropdownModule,
    ModalModule,
    NgbDatepickerModule,
    DiscardModalComponent,
    AssessmentComponent,
    NoteEditModalComponent, NoteEditComponent,
    CareerPlanListComponent, CareerPlanSelectComponent, CareerPlanActivitySelectComponent,
    BookmarkComponent,
    DebounceDirective,
    CasemanagerviewComponent,
    PopoverModule,
    SafePipe
  ],
  entryComponents: [NoteEditModalComponent, ConfirmModalComponent],
  providers: [IdentityService, PopoverConfig]
})
export class SharedModule { }
